import React from 'react'
import "./Section01.css"
import servicesbanner from "../../../../../assets/Services/servicesBanner4.png"

const Section01 = () => {
  return (
    <>
    <div className='servicesMainBanner'>
        <div className='d-flex flex-column-reverse flex-lg-row align-items-center justify-content-center justify-content-lg-between p-4 mx-lg-auto h-100'>
          <div className='ms-0 ms-lg-5 mt-5 mt-lg-0 servicesBannerLeft'>
            <h1 className='text-white'>Introducing <br /> <span className='p-1 bg-white'>Now and Forever Fuel!</span></h1>
            <p className='text-white mb-3'>Now and Forever's latest venture into the realm of automotive excellence comes from our very own fuel brand. With an unwavering commitment to quality and affordability, our fuel brand promises to revolutionize how you power your vehicle</p>
            <button className="btn btn-sm btn-outline-light rounded-5 px-3 py-2 my-4">Nearest Store</button>
          </div>
          <div className='me-0 me-lg-5'>
            <img width={400} height={300} className='img-fluid' src={servicesbanner} alt="" draggable='false' />
          </div>
        </div>
      </div>
    </>
  )
}

export default Section01